import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-bold",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-h-1",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M19 18v-8l-2 2\"></path><path d=\"M4 6v12\"></path><path d=\"M12 6v12\"></path><path d=\"M11 18h2\"></path><path d=\"M3 18h2\"></path><path d=\"M4 12h8\"></path><path d=\"M3 6h2\"></path><path d=\"M11 6h2\"></path>", 9)
const _hoisted_16 = [
  _hoisted_7
]
const _hoisted_17 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-h-2",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0\"></path><path d=\"M4 6v12\"></path><path d=\"M12 6v12\"></path><path d=\"M11 18h2\"></path><path d=\"M3 18h2\"></path><path d=\"M4 12h8\"></path><path d=\"M3 6h2\"></path><path d=\"M11 6h2\"></path>", 9)
const _hoisted_27 = [
  _hoisted_18
]
const _hoisted_28 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-h-3",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M19 14a2 2 0 1 0 -2 -2\"></path><path d=\"M17 16a2 2 0 1 0 2 -2\"></path><path d=\"M4 6v12\"></path><path d=\"M12 6v12\"></path><path d=\"M11 18h2\"></path><path d=\"M3 18h2\"></path><path d=\"M4 12h8\"></path><path d=\"M3 6h2\"></path><path d=\"M11 6h2\"></path>", 10)
const _hoisted_39 = [
  _hoisted_29
]
const _hoisted_40 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-italic",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", { d: "M11 5l6 0" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("path", { d: "M7 19l6 0" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("path", { d: "M14 5l-4 14" }, null, -1)
const _hoisted_45 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-list",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M9 6l11 0\"></path><path d=\"M9 12l11 0\"></path><path d=\"M9 18l11 0\"></path><path d=\"M5 6l0 .01\"></path><path d=\"M5 12l0 .01\"></path><path d=\"M5 18l0 .01\"></path>", 7)
const _hoisted_54 = [
  _hoisted_47
]
const _hoisted_55 = {
  key: 6,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-list-numbers",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M11 6h9\"></path><path d=\"M11 12h9\"></path><path d=\"M12 18h8\"></path><path d=\"M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4\"></path><path d=\"M6 10v-6l-2 2\"></path>", 6)
const _hoisted_62 = [
  _hoisted_56
]
const _hoisted_63 = {
  key: 7,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-blockquote",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M6 15h15\"></path><path d=\"M21 19h-15\"></path><path d=\"M15 11h6\"></path><path d=\"M21 7h-6\"></path><path d=\"M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2\"></path><path d=\"M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2\"></path>", 7)
const _hoisted_71 = [
  _hoisted_64
]
const _hoisted_72 = {
  key: 8,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-code",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("path", { d: "M7 8l-4 4l4 4" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("path", { d: "M17 8l4 4l-4 4" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("path", { d: "M14 4l-4 16" }, null, -1)
const _hoisted_77 = [
  _hoisted_73,
  _hoisted_74,
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = {
  key: 9,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-back-up",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("path", { d: "M9 14l-4 -4l4 -4" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("path", { d: "M5 10h11a4 4 0 1 1 0 8h-1" }, null, -1)
const _hoisted_82 = [
  _hoisted_79,
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = {
  key: 10,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-forward-up",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("path", { d: "M15 14l4 -4l-4 -4" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("path", { d: "M19 10h-11a4 4 0 1 0 0 8h1" }, null, -1)
const _hoisted_87 = [
  _hoisted_84,
  _hoisted_85,
  _hoisted_86
]


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorIconsComponent',
  props: {
  type: {
    type: String,
    default: ""
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.type == 'bold')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
      : _createCommentVNode("", true),
    (__props.type == 'h1')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_16))
      : _createCommentVNode("", true),
    (__props.type == 'h2')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_27))
      : _createCommentVNode("", true),
    (__props.type == 'h3')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_39))
      : _createCommentVNode("", true),
    (__props.type == 'italic')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_40, _hoisted_45))
      : _createCommentVNode("", true),
    (__props.type == 'ul')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_46, _hoisted_54))
      : _createCommentVNode("", true),
    (__props.type == 'ol')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_55, _hoisted_62))
      : _createCommentVNode("", true),
    (__props.type == 'blockquote')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_63, _hoisted_71))
      : _createCommentVNode("", true),
    (__props.type == 'code')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_72, _hoisted_77))
      : _createCommentVNode("", true),
    (__props.type == 'undo')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_78, _hoisted_82))
      : _createCommentVNode("", true),
    (__props.type == 'redo')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_83, _hoisted_87))
      : _createCommentVNode("", true)
  ]))
}
}

})